/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetDay } from '../../models/meet-day';

export interface UpdateMeetDay$Params {
  id: string;
      body?: MeetDay
}

export function updateMeetDay(http: HttpClient, rootUrl: string, params: UpdateMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDay>> {
  const rb = new RequestBuilder(rootUrl, updateMeetDay.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeetDay>;
    })
  );
}

updateMeetDay.PATH = '/meetday/{id}';
